// https://github.com/Carpe-Lotion/base-theme/wiki/Product-Form-Architecture-Guide-(10%E2%80%902025)
// log ProductFormStore.getState('form-0') in console to see current form state 

function devLog(...args) {
    if (localStorage.getItem('pdpProductFormDebugMode') === 'true') {
        console.log('[product-form-new]', ...args);
    }
}
function devWarn(...args) {
    if (localStorage.getItem('pdpProductFormDebugMode') === 'true') {
        console.warn('[product-form-new]', ...args);
    }
}
function devError(...args) {
    if (localStorage.getItem('pdpProductFormDebugMode') === 'true') {
        console.error('[product-form-new]', ...args);
    }
}

const enrichedVariantData = {
    // Women's Scents
    'Fresh Powder': { color: '#93C2E0' },
    'Citrus & Salt': { color: '#3362ad' },
    'Coastal Clean': { color: '#00b5b0' },
    'Cucumber Mint': { color: '#00a76b' },
    'Lavender Citrus': { color: '#8b7ab9' },
    'Mountain Breeze': { color: '#3b7898' },
    'Vanilla Peach': { color: '#fcc58a' },
    'Tropical Berry': { color: '#e43d96' },
    'Rose Water': { color: '#d00a54' },
    'Amber Glow': { color: '#d2661b' },
    'Coconut Vanilla': { color: '#a65b0c' },
    'Soft Cashmere': { color: '#ac847b' },
    'Birchwood & Lavender': { color: '#00562a' },
    'Fragrance Free': { color: '#f9f1ee' },
    // Men's Scents
    'Fresh Wave': { color: '#00afe9' },
    'Clean Sport': { color: '#00b5b0' },
    'Aloe & Eucalyptus': { color: '#4c8477' },
    'Citrus & Cedar': { color: '#ed1b30' },
    'Amber Dusk': { color: '#be5f59' },
    'Sea Salt & Coconut': { color: '#c99a7d' },
    'Bergamot & Oud': { color: '#a53515' },
    'Sandalwood': { color: '#7a4a18' },
    'Ocean Storm': { color: '#003665' },
    'Bourbon Pepper': { color: '#040f19' },
    // Web Only Scents
    'Cucumber Splash': { color: '#6cae47' },
    'Midnight Rain': { color: '#38115e' },
    'Orchard Mist': { color: '#79c47e' },
    'Warm Vanilla': { color: '#f89626' },
    'Eucalyptus': { color: '#728a7e' },
    // old scents
    'Cucumber Spa': { color: '#00a76b' },
    'Vanilla': { color: '#FCE3B3' },
    // clinical regimen
    'Mandarin': { color: '#F78E20' },
    'Fresh Linen': { color: '#3E2B56' },
    // primer
    'Deep Tint': { color: '#653C27' },
    'Light Tint': { color: '#CE9E7B' },
    // hats
    'Black': { color: "#111111" },
    'Gray': { color: "#3A3A3A" },
    'Navy': { color: "#1F2A44" },
    'Pink': { color: "#E6A0AA" },
    'Spruce': { color: "#1F4D3A" },
    'Stone': { color: "#D6C6B8" }
};

class ProductFormStore {
    static state = {};
    static listeners = {};

    static initializeState(formId, initialData = {}) {
        const sourceData = ProductFormStore._buildInitialSourceData(initialData);
        const computedData = ProductFormStore._computeDerivedState(sourceData);

        ProductFormStore.state[formId] = {
            ...sourceData,
            computed: computedData
        };

        ProductFormStore._notify(formId);
    }

    static _getDefaultVariantSelection(product, quantity = 1) {
        if (!product.variants || product.variants.length === 0) {
            return [];
        }

        return [{
            variantId: product.variants[0].id,
            quantity: quantity,
            properties: {
                itemTotal: product.itemTotal * quantity
            }
        }];
    }

    static _buildInitialSourceData(initialData) {
        const formType = initialData.formType || 'simple';
        const hasSellingPlans = initialData.hasSellingPlans !== false
            && Array.isArray(initialData.sellingPlans)
            && initialData.sellingPlans.length > 0;
        const defaultPurchaseType = hasSellingPlans ? 'subscribe' : 'onetime';

        const selections = {
            targetQuantity: initialData.selectedQuantity || 1,
            purchaseType: initialData.selectedPurchaseType || defaultPurchaseType,
            variants: []
        };

        const product = {
            id: initialData.productId,
            title: initialData.productTitle,
            variants: initialData.variants || [],
            sellingPlans: initialData.sellingPlans || [],
            hasSellingPlans: initialData.hasSellingPlans !== false && (initialData.sellingPlans?.length > 0),
            itemTotal: initialData.itemTotal,
            price: initialData.price || 0,
            rechargeBundleConfig: initialData.rechargeBundleConfig || null,
            packConfig: initialData.packConfig || null,
            quantityThresholds: initialData.quantityThresholds || [],
            currencySymbol: initialData.currencySymbol || '',
            countryIsoCode: initialData.countryIsoCode || ''
        };

        // auto-select first available variant
        if (formType !== 'multi-variant') {
            selections.variants = ProductFormStore._getDefaultVariantSelection(
                product,
                initialData.selectedQuantity || 1
            );
        }

        return {
            formType,
            product,
            selections
        };
    }


    static _computeDerivedState(sourceData) {
        const quantityMetrics = ProductFormStore._calculateQuantityMetrics(sourceData);
        const subscriptionMetrics = ProductFormStore._calculateSubscriptionMetrics(sourceData);
        const pricingMetrics = ProductFormStore._calculatePricingMetrics(sourceData, subscriptionMetrics);
        const validationMetrics = ProductFormStore._calculateValidationMetrics(
            quantityMetrics,
            pricingMetrics,
            sourceData
        );
        return {
            ...quantityMetrics,
            ...subscriptionMetrics,
            ...pricingMetrics,
            ...validationMetrics
        };
    }

    static _calculateQuantityMetrics(sourceData) {
        const actualQuantity = sourceData.selections.variants.reduce(
            (sum, item) => sum + item.quantity, 0
        );
        const targetQuantity = sourceData.selections.targetQuantity;
        const quantityMismatch = actualQuantity !== sourceData.selections.targetQuantity;
        const quantityShortfall = sourceData.selections.targetQuantity - actualQuantity;

        return {
            actualQuantity,
            targetQuantity,
            quantityMismatch,
            quantityShortfall
        };
    }


    static _getActivePackData(sourceData) {
        // Multi-variant forms don't use pack products
        if (sourceData.formType === 'multi-variant') {
            return null;
        }

        // No pack config means single product only
        if (!sourceData.product.packConfig?.packs) {
            return null;
        }

        const targetQuantity = sourceData.selections.targetQuantity;
        const pack = sourceData.product.packConfig.packs[targetQuantity];

        // Return pack if it exists, otherwise null
        return pack || null;
    }

    static _calculateSubscriptionMetrics(sourceData) {
        const isSubscription = sourceData.selections.purchaseType === 'subscribe';

        if (!isSubscription) {
            return {
                sellingPlanId: null
            };
        }

        // Get the correct pack data based on quantity
        const activePackData = ProductFormStore._getActivePackData(sourceData);

        // if no activePackData, not a multi-pack. Use the product's selling plan
        if (!activePackData?.sellingPlans || activePackData.sellingPlans.length === 0) {
            const productSellingPlans = sourceData.product.sellingPlans;
            if (!productSellingPlans?.length) {
                return { sellingPlanId: null };
            }
            // TODO-find based on name, not just getting the first one
            const productSellingPlanId = productSellingPlans[0].id;
            return {
                sellingPlanId: productSellingPlanId
            };
        }

        // otherwise, get the selling plan  from the activePackData
        // TODO- find based on name
        const sellingPlan = activePackData.sellingPlans[0];
        return {
            sellingPlanId: sellingPlan.id,
            activeProductId: activePackData.productId,
            isPack: activePackData.isPack
        };
    }

    static _getDiscountTable() {
        return {
            1: 0,
            2: 15,
            3: 20,
            5: 25,
            6: 30
        };
    }

    static _calculateEffectiveItemTotal(baseItemTotal, selectedQuantity, purchaseType) {
        const quantityMultiplier = selectedQuantity;
        const subscriptionBonus = purchaseType === 'subscribe' ? 2 : 0;
        return (baseItemTotal * quantityMultiplier) + subscriptionBonus;
    }

    static _getDiscountPercentage(effectiveItemTotal) {
        const table = ProductFormStore._getDiscountTable();
        // Find the highest applicable discount
        const sortedKeys = Object.keys(table).map(Number).sort((a, b) => b - a);
        for (const threshold of sortedKeys) {
            if (effectiveItemTotal >= threshold) {
                return table[threshold];
            }
        }
        return 0;
    }

    static _calculatePurchaseTypePrice(basePrice, baseItemTotal, targetQuantity, purchaseType, productId = null, unitCount = 1) {
        const effectiveItemTotal = this._calculateEffectiveItemTotal(
            baseItemTotal,
            targetQuantity,
            purchaseType
        );

        // A/B Test: Check for discount override
        const overrideDiscount = productId ? getReducedUAPricingDiscountOverride(productId, targetQuantity, purchaseType) : null;
        const discountPercentage = overrideDiscount !== null ? overrideDiscount : this._getDiscountPercentage(effectiveItemTotal);

        // Shopify's discount function allocates "each": it discounts a single unit, rounds
        // that, then multiplies by the line quantity. Rounding the line total instead drifts
        // a cent or two per unit, so round per unit here to match what the cart will charge.
        const units = unitCount > 0 ? unitCount : 1;
        const rawUnitPrice = (basePrice / units) * (1 - discountPercentage / 100);

        // Use Math.round for A/B test override, Math.ceil for standard pricing
        const roundedUnitPrice = overrideDiscount !== null ? Math.round(rawUnitPrice) : Math.ceil(rawUnitPrice);
        const discountedPrice = roundedUnitPrice * units;
        return {
            basePrice,
            discountedPrice,
            discountPercentage,
            hasDiscount: discountPercentage > 0 && basePrice !== discountedPrice
        };
    }
    static COUNTRY_CURRENCIES = {
        CA: 'CA',
        AU: 'AU',
    };

    static _getPlaceholderPrice(sourceData, quantity) {
        // Try to use base product variants first
        if (sourceData.product.variants.length > 0) {
            return sourceData.product.variants[0].price * quantity;
        }

        // Fallback: for pack products with no base variants (out of stock scenario)
        if (sourceData.product.packConfig?.packs) {
            const activePack = ProductFormStore._getActivePackData(sourceData);
            return activePack?.variants?.[0]?.price || 0;
        }

        // Fallback: use product base price when all variants are out of stock
        if (sourceData.product.price && sourceData.product.price > 0) {
            return sourceData.product.price * quantity;
        }

        // No pricing data available
        return 0;
    }

    static _calculatePricingMetrics(sourceData, subscriptionMetrics) {
        // Calculate actual quantity (needed for multi-variant logic)
        const actualQuantity = sourceData.selections.variants.reduce(
            (sum, item) => sum + item.quantity, 0
        );

        let quantityForPricing;

        if (sourceData.formType === 'multi-variant') {
            quantityForPricing = actualQuantity > 0 ? actualQuantity : 1;
        } else {
            quantityForPricing = sourceData.selections.targetQuantity;
        }

        let basePrice = 0;

        if (sourceData.selections.variants.length > 0) {
            // User has made selections - calculate actual price
            basePrice = sourceData.selections.variants.reduce((sum, item) => {
                const variant = sourceData.product.variants.find(v => v.id === item.variantId);
                return sum + (variant ? variant.price * item.quantity : 0);
            }, 0);
        } else {
            // No selections yet - show placeholder price
            basePrice = this._getPlaceholderPrice(sourceData, quantityForPricing);
        }

        // For multi-variant forms still building to target, override with placeholder
        if (sourceData.formType === 'multi-variant' && actualQuantity < quantityForPricing) {
            basePrice = this._getPlaceholderPrice(sourceData, quantityForPricing);
        }

        const baseItemTotal = sourceData.product.itemTotal || 1;

        // Calculate pricing for BOTH purchase types using the determined quantity
        // A pack enters the cart as one unit; everything else as N units. This has to match
        // the cart line, because Shopify rounds the discount per unit of that line.
        const cartUnitCount = ProductFormStore._getActivePackData(sourceData) ? 1 : quantityForPricing;

        const onetimePricing = this._calculatePurchaseTypePrice(
            basePrice, baseItemTotal, quantityForPricing, 'onetime', sourceData.product.id, cartUnitCount
        );

        const subscribePricing = this._calculatePurchaseTypePrice(
            basePrice, baseItemTotal, quantityForPricing, 'subscribe', sourceData.product.id, cartUnitCount
        );

        // Current selection's pricing
        const currentPricing = sourceData.selections.purchaseType === 'subscribe'
            ? subscribePricing
            : onetimePricing;

        const effectiveItemTotal = this._calculateEffectiveItemTotal(
            baseItemTotal,
            quantityForPricing,
            sourceData.selections.purchaseType
        );

        const countryIsoCode = sourceData.product.countryIsoCode || '';
        const currencyName = ProductFormStore.COUNTRY_CURRENCIES[countryIsoCode];
        const showCurrencyName = Boolean(currencyName);

        return {
            showCurrencyName,
            currencyName,
            basePrice,
            finalPrice: currentPricing.discountedPrice,
            savings: currentPricing.basePrice - currentPricing.discountedPrice,
            discountPercentage: currentPricing.discountPercentage,
            effectiveItemTotal,
            discountMultiplier: 1 - currentPricing.discountPercentage / 100,
            onetimePricing,
            subscribePricing
        };
    }

    static _calculateValidationMetrics(quantityMetrics, pricingMetrics, sourceData) {
        const canAddToCart = quantityMetrics.actualQuantity >= quantityMetrics.targetQuantity &&
            quantityMetrics.actualQuantity > 0;

        const hasSelections = quantityMetrics.actualQuantity > 0;
        const isPriceCalculated = pricingMetrics.finalPrice > 0;


        // Has quantity selector if pack config exists, has progress bar, or quantity thresholds are defined or simple form type 
        const canEditQuantity = !!(sourceData.product.packConfig?.packs ||
            sourceData.product.quantityThresholds?.length > 0) || sourceData.formType == 'simple' || sourceData.formType == 'multi-variant';


        return {
            canAddToCart,
            hasSelections,
            isPriceCalculated,
            canEditQuantity
        };
    }

    static updateState(formId, stateUpdate) {
        if (!ProductFormStore.state[formId]) {
            devWarn(`Attempted to update state for non-existent formId: ${formId}`);
            return;
        }

        const currentState = ProductFormStore.state[formId];
        const newSourceData = ProductFormStore._mergeSourceData(currentState, stateUpdate);
        const newComputedData = ProductFormStore._computeDerivedState(newSourceData);

        ProductFormStore.state[formId] = {
            ...newSourceData,
            computed: newComputedData
        };

        devLog(`${formId} state updated:`, stateUpdate);
        ProductFormStore._notify(formId);
    }


    static _mergeSourceData(currentState, stateUpdate) {
        const merged = {
            formType: currentState.formType,  // ← Must preserve formType
            product: {
                ...currentState.product,
                ...(stateUpdate.product || {})
            },
            selections: {
                ...currentState.selections,
                ...(stateUpdate.selections || {})
            }
        };
        // Auto-adjust target quantity for multi-variant forms
        merged.selections.targetQuantity = ProductFormStore._autoAdjustTargetQuantity(merged);

        return merged;
    }


    static _autoAdjustTargetQuantity(sourceData) {
        if (sourceData.formType !== 'multi-variant') {
            return sourceData.selections.targetQuantity;
        }

        // Count total items, not number of unique variants
        const totalQuantity = sourceData.selections.variants.reduce((sum, v) => sum + v.quantity, 0);
        const currentTarget = sourceData.selections.targetQuantity;
        const quantityThresholds = sourceData.product.quantityThresholds || [];

        devLog('Auto-adjust check:', {
            totalQuantity,
            currentTarget,
            quantityThresholds,
            shouldAdjust: totalQuantity > currentTarget && quantityThresholds.includes(totalQuantity)
        });

        if (totalQuantity > currentTarget && quantityThresholds.includes(totalQuantity)) {
            devLog('Adjusting targetQuantity from', currentTarget, 'to', totalQuantity);
            return totalQuantity;
        }

        return currentTarget;
    }

    static updateTargetQuantity(formId, quantity) {
        const currentState = ProductFormStore.state[formId];

        if (!currentState) {
            devWarn(`Attempted to update quantity for non-existent formId: ${formId}`);
            return;
        }

        // Multi-variant forms: just update the target
        if (currentState.formType === 'multi-variant') {
            ProductFormStore.updateState(formId, {
                selections: { targetQuantity: quantity }
            });
            return;
        }

        // Simple/single-variant forms: sync variant quantities if they exist
        const hasVariants = currentState.selections.variants.length > 0;

        ProductFormStore.updateState(formId, {
            selections: {
                targetQuantity: quantity,
                ...(hasVariants && {
                    variants: currentState.selections.variants.map(v => ({
                        ...v,
                        quantity: quantity,
                        properties: {
                            itemTotal: currentState.product.itemTotal * quantity
                        }
                    }))
                })
            }
        });
    }

    static getState(formId) {
        return ProductFormStore.state[formId];
    }

    static formatPrice(cents, state) {
        const currencySymbol = state.product?.currencySymbol || '$';
        if (state.computed.showCurrencyName) {
            const { currencyName } = state.computed;
            return `${currencySymbol}${currencyName}${(cents / 100).toFixed(2)}`;
        } else {
            return `${currencySymbol}${(cents / 100).toFixed(2)}`;
        }
    }

    static subscribe(formId, callback) {
        if (!ProductFormStore.listeners[formId]) {
            ProductFormStore.listeners[formId] = new Set();
        }
        ProductFormStore.listeners[formId].add(callback);

        const currentState = ProductFormStore.getState(formId);
        if (currentState) {
            callback(currentState);
        }

        return () => {
            ProductFormStore.listeners[formId].delete(callback);
        };
    }

    static _notify(formId) {
        const currentState = ProductFormStore.getState(formId);
        if (ProductFormStore.listeners[formId] && currentState) {
            ProductFormStore.listeners[formId].forEach(callback => {
                callback(currentState);
            });
        }
    }


    static resetSelections(formId) {
        if (!ProductFormStore.state[formId]) {
            devWarn(`Attempted to reset state for non-existent formId: ${formId}`);
            return;
        }

        const currentState = ProductFormStore.state[formId];
        const formType = currentState.formType;
        // Products without selling plans have no subscribe radio to fall back to
        const defaultPurchaseType = currentState.product.hasSellingPlans ? 'subscribe' : 'onetime';

        if (formType === 'simple' || formType === 'multi-pack') {
            // Simple forms: only reset quantity to 1, keep first variant selected
            ProductFormStore.updateState(formId, {
                selections: {
                    targetQuantity: 1,
                    variants: ProductFormStore._getDefaultVariantSelection(currentState.product, 1)
                }
            });
        } else if (formType === 'single-variant') {
            // Single-variant: reset to first variant
            ProductFormStore.updateState(formId, {
                selections: {
                    targetQuantity: 1,
                    purchaseType: defaultPurchaseType,
                    variants: ProductFormStore._getDefaultVariantSelection(currentState.product, 1)
                }
            });
        } else {
            // Multi-variant: clear everything
            ProductFormStore.updateState(formId, {
                selections: {
                    targetQuantity: 1,
                    purchaseType: defaultPurchaseType,
                    variants: []
                }
            });
        }

        devLog(`${formId} state reset (formType: ${formType})`);
    }

    static refreshAllForms() {
        // Trigger recalculation for all active forms
        Object.keys(ProductFormStore.state).forEach(formId => {
            const currentState = ProductFormStore.state[formId];
            if (currentState) {
                // Empty update triggers recalculation
                ProductFormStore.updateState(formId, {});
            }
        });
    }
}


class BaseComponent {
    constructor({ container, formId, componentName = 'BaseComponent' }) {
        if (!container) {
            throw new Error(`${componentName}: container is required`);
        }
        if (!formId) {
            throw new Error(`${componentName}: formId is required`);
        }

        this.container = container;
        this.formId = formId;
        this.componentName = componentName;

        this.elements = {};
        this.requiredElements = {};
        this.optionalElements = {};

        this.cacheDOMElements();
        this.validateDOMElements();
        this.bindEvents();

        this.unsubscribe = ProductFormStore.subscribe(this.formId, (state) => {
            this.render(state);
        });

        // devLog(`${this.componentName} initialized for form: ${this.formId}`);
    }

    cacheDOMElements() {
    }

    declareElementRequirements() {
    }

    validateDOMElements() {
        this.declareElementRequirements();

        let hasErrors = false;
        let hasWarnings = false;

        Object.entries(this.requiredElements).forEach(([elementName, selector]) => {
            const element = this.elements[elementName];
            if (!element) {
                devError(`${this.componentName}: Required element '${elementName}' not found with selector '${selector}'`);
                hasErrors = true;
            }
        });

        Object.entries(this.optionalElements).forEach(([elementName, selector]) => {
            const element = this.elements[elementName];
            if (!element) {
                // devWarn(`${this.componentName}: Optional element '${elementName}' not found with selector '${selector}'`);
                hasWarnings = true;
            }
        });

        if (hasErrors) {
            devError(`${this.componentName}: Component may not function correctly due to missing required elements`);
        } else if (hasWarnings) {
            // devLog(`${this.componentName}: All required elements found, some optional elements missing`);
        } else if (Object.keys(this.requiredElements).length > 0 || Object.keys(this.optionalElements).length > 0) {
            // devLog(`${this.componentName}: All declared elements found successfully`);
        }
    }

    findElement(selector, isRequired = false) {
        const element = this.container.querySelector(selector);
        if (!element && isRequired) {
            devError(`${this.componentName}: Required element not found with selector '${selector}'`);
        }
        return element;
    }

    findElements(selector, minimumExpected = 0) {
        const elements = this.container.querySelectorAll(selector);
        if (elements.length < minimumExpected) {
            devWarn(`${this.componentName}: Expected at least ${minimumExpected} elements with selector '${selector}', found ${elements.length}`);
        }
        return elements;
    }

    bindEvents() {
    }

    render(state) {
        devWarn(`${this.componentName}: render() method should be overridden by child class`);
    }

    updateState(stateUpdate) {
        ProductFormStore.updateState(this.formId, stateUpdate);
        devLog(`${this.componentName} updated state:`, stateUpdate);
    }

    getCurrentState() {
        return ProductFormStore.getState(this.formId);
    }

    updateTextContent(element, text) {
        if (element && text !== undefined && text !== null) {
            element.textContent = text;
        }
    }

    updateAttribute(element, attribute, value) {
        if (element && attribute && value !== undefined && value !== null) {
            element.setAttribute(attribute, value);
        }
    }

    toggleClass(element, className, condition) {
        if (element && className) {
            if (condition) {
                element.classList.add(className);
            } else {
                element.classList.remove(className);
            }
        }
    }

    destroy() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
        devLog(`${this.componentName} destroyed`);
    }
}

class URLParamHandlerRegistry {
    static handlers = new Map();

    static register(paramName, handlerFunction) {
        URLParamHandlerRegistry.handlers.set(paramName, handlerFunction);
        devLog(`Registered URL param handler: ${paramName}`);
    }

    static getHandler(paramName) {
        return URLParamHandlerRegistry.handlers.get(paramName);
    }

    static getAllHandlers() {
        return URLParamHandlerRegistry.handlers;
    }
}

class URLParamWatcher {
    constructor({ formId, container }) {
        this.formId = formId;
        this.container = container;
        this.currentParams = new Map();
        this.initialized = false;

        this.parseURLParams();
        this.processURLParams();
        this.setupHistoryListener();

        this.initialized = true;
        devLog(`URLParamWatcher initialized for form: ${this.formId}`);
    }

    parseURLParams() {
        const urlParams = new URLSearchParams(window.location.search);
        this.currentParams.clear();

        URLParamHandlerRegistry.getAllHandlers().forEach((handler, paramName) => {
            const value = urlParams.get(paramName);
            if (value !== null) {
                this.currentParams.set(paramName, value);
            }
        });
    }

    processURLParams() {
        this.currentParams.forEach((value, paramName) => {
            const handler = URLParamHandlerRegistry.getHandler(paramName);
            if (handler) {
                try {
                    handler({
                        value,
                        formId: this.formId,
                        container: this.container,
                        state: ProductFormStore.getState(this.formId)
                    });
                    devLog(`URL param handler executed: ${paramName}=${value}`);
                } catch (error) {
                    devError(`URL param handler failed for ${paramName}:`, error);
                }
            }
        });
    }

    setupHistoryListener() {
        // Watch for popstate events (back/forward navigation)
        window.addEventListener('popstate', () => {
            this.parseURLParams();
            this.processURLParams();
        });

        // Watch for pushState/replaceState by overriding them
        const originalPushState = history.pushState;
        const originalReplaceState = history.replaceState;

        const handleStateChange = () => {
            this.parseURLParams();
            this.processURLParams();
        };

        history.pushState = function (...args) {
            originalPushState.apply(history, args);
            handleStateChange();
        };

        history.replaceState = function (...args) {
            originalReplaceState.apply(history, args);
            handleStateChange();
        };
    }

    updateParam(paramName, value) {
        const url = new URL(window.location.href);
        if (value === null || value === undefined || value === '') {
            url.searchParams.delete(paramName);
        } else {
            url.searchParams.set(paramName, value);
        }
        window.history.replaceState({}, '', url);
        this.parseURLParams();
        this.processURLParams();
    }

    getParam(paramName) {
        return this.currentParams.get(paramName);
    }

    hasParam(paramName) {
        return this.currentParams.has(paramName);
    }
}

class ComponentRegistry {
    static components = new Map();

    static register(selector, componentClass) {
        ComponentRegistry.components.set(selector, componentClass);
        // devLog(`Registered component: ${componentClass.name} for selector: ${selector}`);
    }

    static initializeComponents(container, formId) {
        const instances = [];

        ComponentRegistry.components.forEach((ComponentClass, selector) => {
            const elements = container.querySelectorAll(selector);
            elements.forEach(element => {
                try {
                    const instance = new ComponentClass({
                        container: element,
                        formId: formId
                    });
                    instances.push(instance);
                    // devLog(`Initialized ${ComponentClass.name} for formId: ${formId}`);
                } catch (error) {
                    devError(`Failed to initialize ${ComponentClass.name}:`, error);
                }
            });
        });

        return instances;
    }
}

class QuantitySelectorPacks extends BaseComponent {
    constructor(config) {
        super({ ...config, componentName: 'QuantitySelectorPacks' });
    }

    declareElementRequirements() {
        this.requiredElements = {
            quantityButtons: '[data-quantity-option]'
        };
    }

    cacheDOMElements() {
        this.elements.quantityButtons = this.container.querySelectorAll('[data-quantity-option]');
        this.discountElements = new Map();
        this.elements.quantityButtons.forEach(button => {
            const quantity = parseInt(button.dataset.quantityOption);
            this.discountElements.set(quantity, {
                oneTime: button.querySelector('[data-price-discount-type="one-time"]'),
                subscribe: button.querySelector('[data-price-discount-type="subscribe"]')
            });
        });
    }

    bindEvents() {
        this.elements.quantityButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                const selectedQuantity = parseInt(e.currentTarget.dataset.quantityOption);
                this.handleQuantitySelection(selectedQuantity);
            });
        });
    }

    handleQuantitySelection(quantity) {
        const currentState = this.getCurrentState();

        if (currentState.selections.targetQuantity === quantity) {
            return;
        }

        const selectedVariantCount = currentState.selections.variants.length;
        if (selectedVariantCount > quantity) {
            // todo - add toast message saying user must remove some varints from selection to decrease pack size 
            return;
        }

        ProductFormStore.updateTargetQuantity(this.formId, quantity);
    }

    render(state) {
        const { selections } = state;
        const selectedPurchaseType = selections.purchaseType;

        this.elements.quantityButtons.forEach(button => {
            const quantity = parseInt(button.dataset.quantityOption);
            const isSelected = state.selections.targetQuantity === quantity;
            this.toggleClass(button, 'pf-qs__button--selected', isSelected);
            button.setAttribute('aria-pressed', isSelected.toString());
        });

        this.discountElements.forEach((discounts, quantity) => {
            if (quantity > 1) { // Only multi-packs have discounts
                const showOneTime = selectedPurchaseType === 'onetime';
                const showSubscribe = selectedPurchaseType === 'subscribe';

                if (discounts.oneTime) {
                    this.toggleClass(discounts.oneTime, 'hidden', !showOneTime);
                }

                if (discounts.subscribe) {
                    this.toggleClass(discounts.subscribe, 'hidden', !showSubscribe);
                }
            }
        });
    }
}

class QuantitySelectorProgressBar extends BaseComponent {
    constructor(config) {
        if (!config.formId) {
            const form = config.container.closest('[data-product-form]');
            config.formId = form?.getAttribute('data-product-form-id');
        }
        super({ ...config, componentName: 'QuantitySelectorProgressBar' });

        // Set this after super
        this.milestones = this.extractMilestonesFromDOM();

        // Manually trigger first render now that we're ready
        const currentState = ProductFormStore.getState(this.formId);
        if (currentState) {
            this.render(currentState);
        }
    }
    extractMilestonesFromDOM() {
        const milestoneElements = this.container.querySelectorAll('[data-milestone]');
        const milestones = Array.from(milestoneElements)
            .map(el => parseInt(el.dataset.milestone))
            .filter(num => !isNaN(num))
            .sort((a, b) => a - b);

        if (milestones.length === 0) {
            devWarn(`${this.componentName}: No milestones found in DOM, falling back to default [1, 2, 3, 6]`);
            return [1, 2, 3, 6];
        }

        return milestones;
    }

    declareElementRequirements() {
        this.requiredElements = {
            progressFill: '[data-progress-fill]'
        };
        this.optionalElements = {
            milestones: '[data-milestone]',
            currentQuantityLabel: '[data-current-quantity-label]',
            nextMilestoneLabel: '[data-next-milestone-label]',
            currentPriceLabel: '[data-current-price-label]',
            nextPriceLabel: '[data-next-price-label]'
        };
    }

    cacheDOMElements() {
        this.elements.progressFill = this.findElement('[data-progress-fill]');
        this.elements.milestones = Array.from(this.findElements('[data-milestone]'));
        this.elements.currentQuantityLabel = this.findElement('[data-current-quantity-label]');
        this.elements.nextMilestoneLabel = this.findElement('[data-next-milestone-label]');
        this.elements.currentPriceLabel = this.findElement('[data-current-price-label]');
        this.elements.nextPriceLabel = this.findElement('[data-next-price-label]');
    }

    bindEvents() {
        // Milestone clicks disabled for now
    }

    getNextMilestone(currentQuantity) {
        if (!this.milestones || this.milestones.length === 0) return;
        return this.milestones.find(m => m > currentQuantity) || this.milestones[this.milestones.length - 1];
    }

    getPreviousMilestone(currentQuantity) {
        if (!this.milestones || this.milestones.length === 0) return;
        const previous = [...this.milestones].reverse().find(m => m < currentQuantity);
        return previous || this.milestones[0];
    }

    calculateProgress(currentQuantity) {
        if (!this.milestones || this.milestones.length === 0) return 0;
        if (currentQuantity === 0) return 0;

        const maxMilestone = this.milestones[this.milestones.length - 1];
        if (currentQuantity >= maxMilestone) return 100;

        let previousMilestone = 0;
        let nextMilestone = this.milestones[0];
        let milestoneIndex = 0;

        for (let i = 0; i < this.milestones.length; i++) {
            if (currentQuantity >= this.milestones[i]) {
                previousMilestone = this.milestones[i];
                nextMilestone = this.milestones[i + 1] || this.milestones[i];
                milestoneIndex = i;
            } else {
                nextMilestone = this.milestones[i];
                break;
            }
        }

        const segmentSize = 100 / (this.milestones.length - 1);

        if (currentQuantity === previousMilestone) {
            return milestoneIndex * segmentSize;
        }

        const range = nextMilestone - previousMilestone;
        const progress = currentQuantity - previousMilestone;
        const percentInSegment = (progress / range);

        return (milestoneIndex * segmentSize) + (percentInSegment * segmentSize);
    }

    getPriceForQuantity(state, quantity, purchaseType) {
        if (!state || !state.product) return 0;

        const { product } = state;
        const baseVariantPrice = product.variants && product.variants.length > 0
            ? product.variants[0].price
            : 0;
        const baseItemTotal = product.itemTotal || 1;

        const totalBasePrice = baseVariantPrice * quantity;

        const pricing = ProductFormStore._calculatePurchaseTypePrice(
            totalBasePrice,
            baseItemTotal,
            quantity,
            purchaseType,
            product.id,
            quantity
        );

        const totalCents = pricing.discountedPrice;

        // A/B Test: Use Math.floor for per-unit when override applies, Math.round otherwise
        const isTestOverride = getReducedUAPricingDiscountOverride(product.id, quantity, purchaseType) !== null;
        const perUnitCents = isTestOverride ? Math.floor(totalCents / quantity) : Math.round(totalCents / quantity);
        return perUnitCents;
    }

    render(state) {
        if (!this.milestones) {
            return; // ← Just exit early, will render again soon
        }

        if (!state || !state.selections || !state.computed) return;

        const { selections, computed } = state;
        const currentQuantity = computed.actualQuantity || 0;
        const purchaseType = selections.purchaseType;

        // Update progress bar fill
        const progressPercent = this.calculateProgress(currentQuantity);
        if (this.elements.progressFill) {
            this.elements.progressFill.style.width = `${progressPercent}%`;
        }

        // Update milestone states
        const milestoneElements = this.elements.milestones || [];
        if (Array.isArray(milestoneElements) && milestoneElements.length > 0) {
            milestoneElements.forEach(milestone => {
                const milestoneQuantity = parseInt(milestone.dataset.milestone);

                const isActive = currentQuantity >= milestoneQuantity;
                const isCurrent = currentQuantity === milestoneQuantity;

                this.toggleClass(milestone, 'is-active', isActive);
                this.toggleClass(milestone, 'is-current', isCurrent);

                const milestoneContainer = milestone.closest('.pf-qsp__milestone-item');
                const priceLabel = milestoneContainer ? milestoneContainer.querySelector('[data-milestone-price]') : null;

                if (priceLabel) {
                    let value;

                    // unless milestoneQuantity is 1, then always show the full price with no discount 
                    if (milestoneQuantity === 1) {
                        value = this.getPriceForQuantity(state, milestoneQuantity, 'one-time');
                    } else {
                        value = this.getPriceForQuantity(state, milestoneQuantity, purchaseType);
                    }

                    const newText = ProductFormStore.formatPrice(value, state) + ' ea';
                    this.updateTextContent(priceLabel, newText);
                }
            });
        }

        // Update current quantity label
        if (this.elements.currentQuantityLabel) {
            const unitWord = currentQuantity === 1 ? 'stick' : 'sticks';
            this.updateTextContent(this.elements.currentQuantityLabel, `${currentQuantity} ${unitWord}`);
        }

        // Update current price
        if (this.elements.currentPriceLabel) {
            if (currentQuantity > 0) {
                const currentPrice = this.getPriceForQuantity(state, currentQuantity, purchaseType);
                this.updateTextContent(this.elements.currentPriceLabel, ProductFormStore.formatPrice(currentPrice, state));
            } else {
                this.updateTextContent(this.elements.currentPriceLabel, '$0.00');
            }
        }

        // Update next milestone info
        const nextMilestone = this.getNextMilestone(currentQuantity);
        const maxMilestone = this.milestones[this.milestones.length - 1];

        if (this.elements.nextMilestoneLabel) {
            if (currentQuantity >= maxMilestone) {
                this.elements.nextMilestoneLabel.textContent = 'Maximum discount unlocked! 🎉';
            } else {
                const itemsToNext = nextMilestone - currentQuantity;
                const unitWord = itemsToNext === 1 ? 'stick' : 'sticks';
                this.elements.nextMilestoneLabel.textContent = `Add ${itemsToNext} more ${unitWord} to unlock better pricing`;
            }
        }

        // Update next milestone price
        if (this.elements.nextPriceLabel) {
            if (currentQuantity < maxMilestone) {
                const nextPrice = this.getPriceForQuantity(state, nextMilestone, purchaseType);
                const nextPricePerStick = Math.ceil(nextPrice / nextMilestone);
                this.updateTextContent(this.elements.nextPriceLabel, ProductFormStore.formatPrice(nextPricePerStick, state) + ' ea');
            } else {
                this.updateTextContent(this.elements.nextPriceLabel, '');
            }
        }
    }
}


class QuantitySelectorSimple extends BaseComponent {
    constructor(config) {
        super({ ...config, componentName: 'QuantitySelectorSimple' });
    }

    declareElementRequirements() {
        this.requiredElements = {
            input: '[data-quantity-input]',
            decreaseButton: '[data-quantity-decrease]',
            increaseButton: '[data-quantity-increase]'
        };
    }

    cacheDOMElements() {
        this.elements.input = this.findElement('[data-quantity-input]');
        this.elements.decreaseButton = this.findElement('[data-quantity-decrease]');
        this.elements.increaseButton = this.findElement('[data-quantity-increase]');
    }

    bindEvents() {
        if (this.elements.input) {
            this.elements.input.addEventListener('change', (e) => {
                const quantity = parseInt(e.target.value) || 1;
                this.handleQuantityChange(quantity);
            });

            this.elements.input.addEventListener('blur', (e) => {
                const quantity = parseInt(e.target.value) || 1;
                if (quantity < 1) {
                    e.target.value = 1;
                    this.handleQuantityChange(1);
                }
            });
        }

        if (this.elements.decreaseButton) {
            this.elements.decreaseButton.addEventListener('click', () => {
                const currentQuantity = parseInt(this.elements.input.value) || 1;
                const newQuantity = Math.max(1, currentQuantity - 1);
                this.handleQuantityChange(newQuantity);
            });
        }

        if (this.elements.increaseButton) {
            this.elements.increaseButton.addEventListener('click', () => {
                const currentQuantity = parseInt(this.elements.input.value) || 1;
                const newQuantity = currentQuantity + 1;
                this.handleQuantityChange(newQuantity);
            });
        }
    }

    handleQuantityChange(quantity) {
        const validQuantity = Math.max(1, quantity);
        ProductFormStore.updateTargetQuantity(this.formId, validQuantity);
    }

    render(state) {
        if (this.elements.input) {
            this.elements.input.value = state.selections.targetQuantity;
        }

        if (this.elements.decreaseButton) {
            const isMinimum = state.selections.targetQuantity <= 1;
            this.elements.decreaseButton.disabled = isMinimum;
            this.toggleClass(this.elements.decreaseButton, 'is-disabled', isMinimum);
        }
    }
}
class SingleVariantSelector extends BaseComponent {

    constructor(config) {
        super({ ...config, componentName: 'SingleVariantSelector' });
    }

    declareElementRequirements() {
        this.requiredElements = {
            options: '[data-variant-option]'
        };
    }

    cacheDOMElements() {
        this.elements.options = this.findElements('[data-variant-option]');
        this.elements.optionSwatches = this.findElements('[data-swatch-id]');
    }

    bindEvents() {
        this.elements.options.forEach(option => {
            option.addEventListener('click', (e) => {
                const variantId = parseInt(option.dataset.variantOption);
                this.handleVariantSelect(variantId);
            });
        });
    }

    handleVariantSelect(variantId) {
        const currentState = this.getCurrentState();
        const targetQuantity = currentState.selections.targetQuantity;

        ProductFormStore.updateState(this.formId, {
            selections: {
                variants: [{
                    variantId: variantId,
                    quantity: targetQuantity
                }]
            }
        });
        this.updateGalleryImageByVariantId(variantId);
    }

    updateGalleryImageByVariantId(variantId) {
        const currentState = this.getCurrentState();
        // don't update on products without variant images, like ALL DAY MATTE COLLECTTION
        // TODO get variant images for ADM COLLECTION 
        const excludedProductIds = [7007099355269];
        const canGoToSlideByVariantId = !excludedProductIds.includes(currentState.product.id);
        if (canGoToSlideByVariantId) {

            const container = document.getElementById('pdp-product-gallery');
            if (!container) {
                console.error('No container found for gallery slides');
                return;
            }

            const variantsContainer = container.querySelector('[data-variant-images]');
            if (!variantsContainer) {
                console.error('No variants container found for gallery slides');
                return;
            }

            const variantSlide = variantsContainer.querySelector(`[data-variant-id="${variantId}"]`);
            if (!variantSlide) {
                console.error('No variant container found for variant id', variantId);
                return;
            }

            const mainSlide = container.querySelector('[data-gallery-slide-main]');
            if (!mainSlide) {
                console.error('No main slide found for gallery slides');
                return;
            }

            mainSlide.innerHTML = variantSlide.innerHTML;
        }
    }

    renderSwatch(swatchElement, variantTitle) {
        // First check for exact match
        if (enrichedVariantData[variantTitle]) {
            swatchElement.style.setProperty('--swatch-color', enrichedVariantData[variantTitle].color);
            swatchElement.classList.add('is-loaded');

            return;
        }

        // Then check if variant title contains any enriched data key
        const foundKey = Object.keys(enrichedVariantData).find(key =>
            variantTitle.includes(key)
        );


        if (foundKey) {
            swatchElement.style.setProperty('--swatch-color', enrichedVariantData[foundKey].color);
            swatchElement.classList.add('is-loaded');
        }
    }

    render(state) {
        const selectedVariant = state.selections.variants[0];
        if (selectedVariant && selectedVariant.variantId) {
            this.updateGalleryImageByVariantId(selectedVariant.variantId)
        }

        this.elements.options.forEach(option => {
            const variantId = parseInt(option.dataset.variantOption);
            const isSelected = selectedVariant && variantId === selectedVariant.variantId;
            option.setAttribute('aria-selected', isSelected.toString());
            this.toggleClass(option, 'is-selected', isSelected);
        });

        this.elements.optionSwatches.forEach(swatch => {
            const variantTitle = swatch.dataset.swatchId;
            this.renderSwatch(swatch, variantTitle);
        });

    }
}

class MultiVariantSelector extends BaseComponent {
    constructor(config) {
        super({ ...config, componentName: 'MultiVariantSelector' });
    }

    declareElementRequirements() {
        this.requiredElements = {
            variantOptions: '[data-variant-option]'
        };
    }

    cacheDOMElements() {
        this.elements.variantOptions = this.container.querySelectorAll('[data-variant-option]');
        this.variantElementMap = new Map();
        this.elements.targetQuantityItemLabels = this.container.querySelectorAll('[data-target-quantity-item-label]')
        this.elements.variantOptions.forEach(optionEl => {
            const variantId = parseInt(optionEl.dataset.variantOption);

            const variantElements = {
                container: optionEl,
                addContainer: optionEl.querySelector('[data-variant-add-container]'),
                quantityContainer: optionEl.querySelector('[data-variant-quantity-container]'),
                addButton: optionEl.querySelector('[data-variant-add]'),
                quantityDisplay: optionEl.querySelector('[data-variant-quantity]'),
                increaseButton: optionEl.querySelector('[data-variant-increase]'),
                decreaseButton: optionEl.querySelector('[data-variant-decrease]')
            };

            this.variantElementMap.set(variantId, variantElements);

        });
    }

    render(state) {
        const { variants: currentSelections, targetQuantity } = state.selections

        this.elements.targetQuantityItemLabels.forEach(el => {
            const itemWord = targetQuantity === 1 ? 'Item' : 'Items';
            this.updateTextContent(el, `${targetQuantity} ${itemWord}`);
        });

        this.variantElementMap.forEach((elements, variantId) => {
            const selection = currentSelections.find(v => v.variantId === variantId);
            const isSelected = !!selection;
            const quantity = selection ? selection.quantity : 0;

            this.toggleClass(elements.container, 'pf-mvs__option--selected', isSelected);

            elements.quantityDisplay && this.updateTextContent(elements.quantityDisplay, quantity.toString());
            elements.addContainer && this.toggleClass(elements.addContainer, 'hidden', isSelected);
            elements.quantityContainer && this.toggleClass(elements.quantityContainer, 'hidden', !isSelected);

        });
    }

    bindEvents() {
        this.variantElementMap.forEach((elements, variantId) => {
            elements.addButton && elements.addButton.addEventListener('click', () => {
                this.handleAddVariant(variantId);
            });

            elements.increaseButton && elements.increaseButton.addEventListener('click', () => {
                this.handleIncreaseVariant(variantId);
            });
            elements.decreaseButton && elements.decreaseButton.addEventListener('click', () => {
                this.handleDecreaseVariant(variantId);
            });
        });
    }

    handleAddVariant(variantId) {
        const currentState = this.getCurrentState();
        const currentSelections = currentState.selections.variants;
        const existingSelection = currentSelections.find(v => v.variantId === variantId);

        if (existingSelection) {
            this.handleIncreaseVariant(variantId);
        } else {
            const initialQuantity = 1;
            const newSelections = [...currentSelections, { variantId, quantity: initialQuantity }];
            this.updateVariantSelections(newSelections);
        }
    }
    handleIncreaseVariant(variantId) {
        const currentState = this.getCurrentState();
        const currentSelections = currentState.selections.variants;

        const newSelections = currentSelections.map(v => {
            if (v.variantId === variantId) {
                return { ...v, quantity: v.quantity + 1 };
            }
            return v;
        });

        this.updateVariantSelections(newSelections);
    }

    handleDecreaseVariant(variantId) {
        const currentState = this.getCurrentState();
        const currentSelections = currentState.selections.variants;

        const newSelections = currentSelections.map(v => {
            if (v.variantId === variantId) {
                const newQuantity = v.quantity - 1;
                return newQuantity > 0 ? { ...v, quantity: newQuantity } : null;
            }
            return v;
        }).filter(Boolean);

        this.updateVariantSelections(newSelections);
    }

    updateVariantSelections(newSelections) {
        ProductFormStore.updateState(this.formId, {
            selections: { variants: newSelections }
        });
    }
}

class PurchaseTypeSelector extends BaseComponent {
    constructor(config) {
        super({ ...config, componentName: 'PurchaseTypeSelector' });
    }

    cacheDOMElements() {
        this.elements = {
            container: this.container,
            radios: this.container.querySelectorAll('input[type="radio"][name^="purchase-type"]'),
            // Onetime price elements
            onetimeActualPrice: this.container.querySelector('[data-onetime-actual-price]'),
            onetimeComparePrice: this.container.querySelector('[data-onetime-compare-price]'),
            // Subscribe price elements
            subscribeActualPrice: this.container.querySelector('[data-subscribe-actual-price]'),
            subscribeComparePrice: this.container.querySelector('[data-subscribe-compare-price]'),
            subscribeDiscountPercent: this.container.querySelector('[data-subscribe-discount-percent]'),
            // renewal frequency
            renewalFrequency: this.container.querySelector('[data-renewal-frequency]')
        };
    }

    bindEvents() {
        this.elements.radios.forEach(radio => {
            radio.addEventListener('change', (e) => {
                if (e.target.checked) {
                    this.handlePurchaseTypeChange(e.target.value);
                }
            });
        });
    }

    handlePurchaseTypeChange(purchaseType) {
        this.updateState({ selections: { purchaseType: purchaseType } });
    }

    setOtpPriceVisibilityState(stateKey) {
        const states = {
            'both': { compare: true, actual: true },
            'compare': { compare: true, actual: false },
            'actual': { compare: false, actual: true },
        };

        const state = states[stateKey];
        devLog('Setting price visibility state', state);

        if (!state) return;

        this.elements.onetimeComparePrice.classList[state.compare ? 'remove' : 'add']('hidden');
        this.elements.onetimeActualPrice.classList[state.actual ? 'remove' : 'add']('hidden');
    }

    updatePriceDisplays(onetimePricing, subscribePricing, state) {
        // Update onetime actual price
        if (this.elements.onetimeActualPrice) {
            this.updateTextContent(this.elements.onetimeActualPrice, ProductFormStore.formatPrice(onetimePricing.discountedPrice, state));
        }

        // Update subscribe discount percentage
        if (this.elements.subscribeDiscountPercent) {
            this.updateTextContent(this.elements.subscribeDiscountPercent, `${subscribePricing.discountPercentage}%`);
        }

        // Update subscribe actual price
        if (this.elements.subscribeActualPrice) {
            this.updateTextContent(this.elements.subscribeActualPrice, ProductFormStore.formatPrice(subscribePricing.discountedPrice, state));
        }

        // Update compare prices
        if (this.elements.onetimeComparePrice) {
            this.updateTextContent(this.elements.onetimeComparePrice, ProductFormStore.formatPrice(onetimePricing.basePrice, state));
        }
        if (this.elements.subscribeComparePrice) {
            this.updateTextContent(this.elements.subscribeComparePrice, ProductFormStore.formatPrice(subscribePricing.basePrice, state));
        }
    }

    updateRenewalFrequency(targetQuantity, formType) {
        if (!this.elements.renewalFrequency) return;

        // TODO - this should be synced to actual pack selling plans
        if (targetQuantity > 2 && formType === 'multi-pack') {
            this.updateTextContent(this.elements.renewalFrequency, `12 weeks`);
        } else {
            this.updateTextContent(this.elements.renewalFrequency, `4 weeks`);
        }
    }

    updatePriceVisibility(canEditQuantity, quantityToCheck, purchaseType, onetimePricing, subscribePricing) {
        if (!canEditQuantity || quantityToCheck > 1) {
            if (purchaseType === 'onetime') {
                this.setOtpPriceVisibilityState(onetimePricing?.hasDiscount ? 'both' : 'actual');
            } else {
                this.setOtpPriceVisibilityState(subscribePricing?.hasDiscount ? 'compare' : 'actual');
            }
        } else {
            this.setOtpPriceVisibilityState('actual');
        }
    }

    render(state) {
        if (!state.formType || !state.computed || !state.selections) {
            devError('Purchase type selector missing data, will not render')
            return;
        };

        const { formType } = state;
        const { onetimePricing, subscribePricing, canEditQuantity, actualQuantity } = state.computed;
        const { targetQuantity, purchaseType } = state.selections;

        // Sync radio buttons and data-selected-type from state
        this.elements.radios.forEach(radio => {
            const isChecked = radio.value === purchaseType;
            radio.checked = isChecked;
        });
        this.updateAttribute(this.container, 'data-selected-type', purchaseType);

        let quantityToCheck;
        if (formType === 'multi-variant') {
            quantityToCheck = actualQuantity > 0 ? actualQuantity : 1;
        } else {
            quantityToCheck = targetQuantity;
        }

        this.updatePriceDisplays(onetimePricing, subscribePricing, state);
        this.updatePriceVisibility(canEditQuantity, quantityToCheck, purchaseType, onetimePricing, subscribePricing);
        this.updateRenewalFrequency(quantityToCheck, formType);
    }

}

class AddToCartButton extends BaseComponent {
    constructor({ container, formId }) {
        super({
            container,
            formId,
            componentName: 'AddToCartButton'
        });
    }

    cacheDOMElements() {
        this.elements = {
            button: this.findElement('[data-atc-button]'),
            compareAtPrice: this.findElement('[data-compare-at-price]'),
            actualPrice: this.findElement('[data-actual-price]'),
            buttonText: this.findElement('[data-atc-text]'),
            buttonIcon: this.findElement('[data-atc-icon]')
        };
    }

    declareElementRequirements() {
        this.requiredElements = {
            button: '[data-atc-button]'
        };

        this.optionalElements = {
            compareAtPrice: '[data-compare-at-price]',
            actualPrice: '[data-actual-price]',
            buttonText: '[data-atc-text]',
            buttonIcon: '[data-atc-icon]'
        };
    }

    bindEvents() {
        if (this.elements.button) {
            this.elements.button.addEventListener('click', (e) => {
                this.handleAddToCart(e);
            });
        }
    }

    async handleAddToCart(e) {
        e.preventDefault();

        const state = this.getCurrentState();

        if (!state.computed.canAddToCart) {
            devWarn(`${this.componentName}: Add to cart blocked - validation failed`);
            return;
        }

        try {
            this.setLoadingState(true);
            const cartPayload = await ProductFormCart.Payload.build(state);
            devLog('submitting this payload to cart', cartPayload);
            const result = await ProductFormCart.Service.addToCart(cartPayload, state.product.id, state);

            if (result === null) {
                console.error(`${this.componentName}: Failed to add items to cart. Check network tab for details.`);
                return;
            }

            this.handleCartSuccess(result);
        } catch (error) {
            devError(`${this.componentName}: Error in handleAddToCart`, error);
        } finally {
            this.setLoadingState(false);
        }
    }

    handleCartSuccess(result) {
        // Core UI updates are handled automatically by ProductFormCart.Service.addToCart
        // Only handle context-specific actions here
        ProductFormCart.UI.openDrawer();
        this.resetForm();
    }

    resetForm() {
        ProductFormStore.resetSelections(this.formId);
        devLog(`${this.componentName}: Form reset after successful cart addition`);
    }

    setLoadingState(isLoading) {
        if (this.elements.button) {
            this.elements.button.disabled = isLoading;
            this.toggleClass(this.elements.button, 'is-loading', isLoading);
        }
    }

    setupStickyBehavior() {
        if (this.observers?.length > 0) return; // Already setup

        const parentForm = this.container.closest('.pdp-new-product-form-container');
        const trigger = parentForm?.querySelector('.pdp-product-form-container-inner');

        if (!trigger) {
            console.warn('Sticky trigger not found');
            return;
        }

        // Create sentinel right before the ATC button
        const sentinel = document.createElement('div');
        sentinel.style.cssText = 'height: 1px; visibility: hidden; pointer-events: none;';
        sentinel.dataset.stickySentinel = '';

        this.container.parentNode.insertBefore(sentinel, this.container);

        const observer = new IntersectionObserver(([entry]) => {
            // When sentinel scrolls out of view at bottom = button should stick
            // When sentinel is in view = button in natural position
            this.toggleClass(
                this.container,
                'is-sticky',
                !entry.isIntersecting
            );
        }, {
            root: null,
            threshold: 0,
            rootMargin: '0px'
        });

        observer.observe(sentinel);

        this.observers = [observer];
        this.sentinel = sentinel;
    }

    removeStickyBehavior() {
        this.toggleClass(this.container, 'is-sticky', false);
        // Clean up observer
        if (this.observers) {
            this.observers.forEach(obs => obs.disconnect());
            this.observers = null;
        }
        if (this.sentinel) {
            this.sentinel.remove();
            this.sentinel = null;
        }
    }

    render(state) {
        const { computed } = state;

        const { hasSelections } = computed;
        if (state.formType === 'multi-variant') {
            if (hasSelections) {
                this.setupStickyBehavior();
            } else {
                this.removeStickyBehavior();
            }
        }

        if (this.elements.button) {
            this.elements.button.disabled = !computed.canAddToCart;
            this.toggleClass(this.elements.button, 'is-disabled', !computed.canAddToCart);
        }

        if (this.elements.actualPrice && computed.isPriceCalculated) {
            const priceText = ProductFormStore.formatPrice(computed.finalPrice, state);
            this.updateTextContent(this.elements.actualPrice, priceText);
        }

        if (this.elements.compareAtPrice) {
            const hasSavings = computed.savings > 0;
            if (hasSavings) {
                const compareText = ProductFormStore.formatPrice(computed.basePrice, state);
                this.updateTextContent(this.elements.compareAtPrice, compareText);
                this.toggleClass(this.elements.compareAtPrice.parentElement, 'is-visible', true);
            } else {
                this.toggleClass(this.elements.compareAtPrice.parentElement, 'is-visible', false);
            }
        }

        if (this.elements.buttonText) {
            const buttonText = this.getButtonText(state);
            this.updateTextContent(this.elements.buttonText, buttonText);
        }
    }

    getButtonText(state) {
        const { computed, formType } = state;

        const activeButtonText =
            formType === 'multi-variant' ? 'Continue' : 'Add to Cart';

        if (computed.canAddToCart) {
            return activeButtonText;
        }

        const disabledTextStrategies = {
            'multi-variant': this.getMultiVariantDisabledText.bind(this),
            'single-variant': () => 'Choose an Option',
            'multi-pack': () => 'Add to Cart',
            'simple': () => 'Add to Cart'
        };

        const getDisabledText = disabledTextStrategies[formType] || disabledTextStrategies['simple'];
        return getDisabledText(computed);
    }

    getMultiVariantDisabledText(computed) {
        if (computed.hasSelections && computed.quantityShortfall > 0) {
            const itemWord = computed.quantityShortfall === 1 ? 'item' : 'items';
            return `Add ${computed.quantityShortfall} more ${itemWord}`;
        }

        return `Select ${computed.targetQuantity} ${computed.targetQuantity === 1 ? 'item' : 'items'}`;
    }

    destroy() {
        if (this.observers) {
            this.observers.forEach(observer => observer.disconnect());
        } else if (this.observer) {
            this.observer.disconnect();
        }
        super.destroy();
    }
}

// A/B Test: Reduced UA Pricing - Check if adjustment should apply
function shouldApplyReducedUAPricingAdjustment(productId) {
    const TARGET_PRODUCT_ID = 4996364566661;
    return window.reducedUAPricing === true && productId === TARGET_PRODUCT_ID;
}

// A/B Test: Reduced UA Pricing - Get override discount percentage
function getReducedUAPricingDiscountOverride(productId, quantity, purchaseType) {
    if (shouldApplyReducedUAPricingAdjustment(productId) &&
        purchaseType === 'subscribe' &&
        quantity <= 2) {
        return 25; // Override to 25% discount
    }
    return null;
}

class ProductFormCart {
    static Payload = class {
        // Main entry point for building cart payloads
        static async build(state) {
            if (!state?.computed?.canAddToCart) {
                throw new Error('Cannot build cart payload: invalid form state');
            }
            try {
                const isRechargeBundle = state.product.rechargeBundleConfig && state.selections.purchaseType === 'subscribe';
                const items = isRechargeBundle
                    ? await ProductFormCart.Payload._buildRechargeBundleItems(state)
                    : ProductFormCart.Payload.buildItems(state);
                return { items };
            } catch (error) {
                devError('ProductFormCart.Payload: Failed to build cart payload', error);
                throw error; // Re-throw for caller to handle
            }
        }

        // Build standard cart items from state
        static buildItems(state) {
            const activePack = ProductFormStore._getActivePackData(state);
            const productItemTotal = state.product.itemTotal;

            if (!activePack) {
                return ProductFormCart.Payload._buildItemsWithoutPack(state, productItemTotal);
            }

            return ProductFormCart.Payload._buildItemsWithPack(state, activePack, productItemTotal);
        }

        // Private: Build items for non-pack products
        static _buildItemsWithoutPack(state, productItemTotal) {
            // item_total is a PER-UNIT weight: the discount function computes
            // quantity × item_total itself. Sending an already-multiplied value here
            // made it square the quantity (qty 3 scored 9 items -> 30% instead of 20%).
            const perUnitItemTotal = productItemTotal || 1;

            return state.selections.variants.map(item => {
                devLog('adding item to cart list', item)
                const itemData = {
                    id: item.variantId,
                    quantity: item.quantity,
                    properties: {
                        item_total: perUnitItemTotal
                    }
                };

                if (state.selections.purchaseType === "subscribe" && state.computed.sellingPlanId) {
                    itemData.selling_plan = state.computed.sellingPlanId;
                }

                return itemData;
            });
        }

        // Private: Build items for pack products
        static _buildItemsWithPack(state, activePack, productItemTotal) {
            // The discount function tiers on the summed item_total across the cart, so a
            // pack line must carry the pack's own item total (its bundle_items_total), not
            // the base product's. Fall back to base × pack size when the metafield is unset.
            // `productItemTotal` is null when the base product has no bundle_items_total
            // metafield; treat that as 1 item, matching the display path's `itemTotal || 1`.
            const packItemTotal = activePack.metafields?.itemTotal
                || (productItemTotal || 1) * state.selections.targetQuantity;

            return state.selections.variants.map(item => {
                const baseVariant = state.product.variants.find(v => v.id === item.variantId);
                const packVariant = activePack.variants.find(v => v.title === baseVariant?.title);
                const itemData = {
                    id: packVariant?.id || item.variantId,
                    quantity: 1,  // Pack products are always qty 1
                    properties: {
                        item_total: packItemTotal
                    }
                };

                if (state.selections.purchaseType === "subscribe" && state.computed.sellingPlanId) {
                    itemData.selling_plan = state.computed.sellingPlanId;
                }

                return itemData;
            });
        }

        // Private: Process Recharge bundle items
        static async _processRechargeBundle(state, bundleCollectionId, bundleProduct) {
            if (typeof recharge === 'undefined' || !recharge.bundle) {
                throw new Error('Recharge bundle SDK not loaded');
            }

            const bundleVariant = bundleProduct.variants[0];
            const sellingPlanAllocation = bundleVariant.selling_plan_allocations[0];

            const config = {
                variantId: bundleVariant.id,
                productId: bundleProduct.id,
                sellingPlanId: sellingPlanAllocation.selling_plan_id,
                handle: bundleProduct.handle
            };

            if (!config.productId || !config.variantId || !config.sellingPlanId || !config.handle) {
                throw new Error('Bundle product configuration error: Missing required data');
            }

            const selections = state.selections.variants.map(item => ({
                collectionId: bundleCollectionId,
                externalProductId: state.product.id,
                externalVariantId: item.variantId,
                quantity: item.quantity,
                sellingPlan: state.selections.purchaseType === "subscribe" ? state.computed.sellingPlanId : null
            }));

            const bundle = {
                externalVariantId: config.variantId,
                externalProductId: config.productId,
                selections: selections
            };

            const bundledCartItems = await recharge.bundle.getDynamicBundleItems(bundle, config.handle);
            return bundledCartItems;
        }

        // Private: Build Recharge bundle cart payload
        static async _buildRechargeBundleItems(state) {
            const { bundleCollectionId, bundleProduct } = state.product.rechargeBundleConfig
            const items = await ProductFormCart.Payload._processRechargeBundle(state, bundleCollectionId, bundleProduct);

            // inside each item, add to the existing properties object the attribute _reduced_ua_pricing_test_variant: true
            const hasReducedUAPricingAdjustment = shouldApplyReducedUAPricingAdjustment(state.product.id);
            if (hasReducedUAPricingAdjustment) {
                items.forEach(item => {
                    item.properties = {
                        ...item.properties,
                        _reduced_ua_pricing_test_variant: "true"
                    };
                });
            }
            return items;
        }
    }

    static Service = class {
        // Add items to cart via Shopify API
        static async addToCart(payload, productId, state) {
            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                devLog(`ProductFormCart.Service: Successfully added to cart`, result);

                ProductFormCart.Service._triggerCheckoutTrackingEvents(state);
                await ProductFormCart.Service.handleSuccess(result);
                return result;

            } catch (error) {
                devError(`ProductFormCart.Service: Failed to add to cart`, error);
                document.dispatchEvent(new CustomEvent('cart:error', {
                    detail: error
                }));
                return null;
            }
        }

        // Handle successful cart additions
        static async handleSuccess(result) {
            const results = await Promise.allSettled([
                ProductFormCart.UI.updateDrawer(),
                ProductFormCart.UI.updateProgress(),
                ProductFormCart.UI.updateIconCount()
            ]);

            const failures = results.filter(r => r.status === 'rejected');
            if (failures.length > 0) {
                console.warn(`ProductFormCart: ${failures.length} UI updates failed`);
            }

            ProductFormCart.UI.dispatchEvents(result);
        }

        static _triggerCheckoutTrackingEvents(state) {

            window._conv_q = window._conv_q || [];

            // PDP - Add to Cart Event (All Purchase Types)
            _conv_q.push(["triggerConversion", '100332547']);

            const isSubscription = state?.selections?.purchaseType === 'subscribe';
            if (isSubscription) {
                // PDP - Add to Cart Event (Subscription)
                _conv_q.push(["triggerConversion", '100333840']);
            } else {
                // PDP - Add to Cart Event (One-Time)
                _conv_q.push(["triggerConversion", '100333841']);
            }

            // PDP - MVS - Add to Cart (by item count)
            const sticks = state?.computed?.actualQuantity ?? 0;
            if (sticks === 1) {
                // PDP - MVS - Add to Cart with 1 Item
                _conv_q.push(["triggerConversion", '100333934']);
            } else if (sticks === 2) {
                // PDP - MVS - Add to Cart with 2 Items
                _conv_q.push(["triggerConversion", '100333935']);
            } else if (sticks === 3) {
                // PDP - MVS - Add to Cart with 3 Items
                _conv_q.push(["triggerConversion", '100333936']);
            } else if (sticks === 4) {
                // PDP - MVS - Add to Cart with 4 Items
                _conv_q.push(["triggerConversion", '100333937']);
            } else if (sticks === 5) {
                // PDP - MVS - Add to Cart with 5 Items
                _conv_q.push(["triggerConversion", '100333938']);
            } else if (sticks >= 6) {
                // PDP - MVS - Add to Cart with 6+ Items
                _conv_q.push(["triggerConversion", '100333939']);
            }
        }

    }

    static UI = class {
        // Update cart drawer contents
        static async updateDrawer() {
            try {
                const response = await fetch('/?section_id=cart-drawer');
                const html = await response.text();

                const container = document.getElementById('offcanvas-cart-drawer');
                if (container) {
                    container.innerHTML = html;

                    // re-hydrate the site discount bar in the cart drawer
                    const siteDiscountBarContainer = document.querySelector("[data-site-discount-bar-type='cart-drawer']");
                    if (siteDiscountBarContainer) {
                        if (window.CartProgress && typeof window.CartProgress.destroyWithin === 'function') {
                            window.CartProgress.destroyWithin(siteDiscountBarContainer);
                        }
                        if (window.CartProgress && typeof window.CartProgress.hydrate === 'function') {
                            window.CartProgress.hydrate(siteDiscountBarContainer);
                        }
                    }
                }
            } catch (error) {
                devError(`ProductFormCart.UI: Failed to update cart drawer`, error);
            }
        }

        // Open the cart drawer
        static openDrawer() {
            const cartIconEl = document.querySelector('[data-drawer-name="cart"]');
            if (cartIconEl) {
                cartIconEl.click();
            }
        }

        // Update cart progress bar
        static async updateProgress() {
            try {
                const response = await fetch('/?section_id=site-discount-bar-site-header');
                const html = await response.text();

                const container = document.querySelector("[data-site-discount-bar-type='site-header']");
                if (container) {
                    console.log('pdp-new-product-form: updateProgress: container found', container)
                    if (window.CartProgress && typeof window.CartProgress.destroyWithin === 'function') {
                        console.log('pdp-new-product-form: updateProgress: destroying within', container)
                        window.CartProgress.destroyWithin(container);
                    }
                    container.innerHTML = html;
                    if (window.CartProgress && typeof window.CartProgress.hydrate === 'function') {
                        console.log('pdp-new-product-form: updateProgress: hydrating', container)
                        window.CartProgress.hydrate(container);
                    }
                }
            } catch (error) {
                devError(`ProductFormCart.UI: Failed to update cart progress`, error);
            }
        }

        // Update cart icon count badge
        static async updateIconCount() {
            try {
                // Fetch current cart data
                const response = await fetch('/cart.json');
                if (!response.ok) {
                    throw new Error(`Failed to fetch cart: ${response.status}`);
                }
                const cart = await response.json();

                // Update cart icon count elements
                const cartCountElements = document.querySelectorAll('.js-cart-item-count');
                cartCountElements.forEach(element => {
                    element.setAttribute('data-item-count', cart.item_count);
                    element.textContent = cart.item_count;
                    element.classList.remove('hidden')
                });

                // Update cart drawer count text
                const cartDrawerCountElements = document.querySelectorAll('.js-cart-item-countDrawer');
                cartDrawerCountElements.forEach(element => {
                    element.setAttribute('data-item-count', cart.item_count);
                    if (cart.item_count > 1) {
                        element.textContent = cart.item_count + " Items";
                    } else {
                        element.textContent = cart.item_count + " Item";
                    }
                });

                devLog(`ProductFormCart.UI: Updated cart icon count to ${cart.item_count}`);
            } catch (error) {
                devError(`ProductFormCart.UI: Failed to update cart icon count`, error);
            }
        }

        // Dispatch cart-related events
        static dispatchEvents(result) {
            // Dispatch refreshCart event for legacy compatibility
            document.dispatchEvent(new Event('refreshCart', { bubbles: true }));

            // Dispatch theme:request_cart_update to trigger cart state update
            document.dispatchEvent(new Event('theme:request_cart_update', { bubbles: true }));

            // Dispatch custom cart:updated event
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: result }));
        }
    }
}

class ProductForm {
    static getProductData(container) {
        const productDataScript = container.querySelector('[data-product-data]');
        if (!productDataScript) {
            return null;
        }

        try {
            return JSON.parse(productDataScript.textContent);
        } catch (e) {
            devError('Product data parse failed', e)
            return null;
        }
    }
    static getQuantityThresholds(container) {
        const buttons = container.querySelectorAll('[data-quantity-option]');
        return Array.from(buttons)
            .map(btn => parseInt(btn.dataset.quantityOption, 10))
            .filter(n => !isNaN(n))
            .sort((a, b) => a - b);
    }

    static getRechargeBundleConfig(container) {
        const rechargeBundleConfigScript = container.querySelector('#recharge-bundle-config');

        if (!rechargeBundleConfigScript) {
            return null;
        }

        try {
            return JSON.parse(rechargeBundleConfigScript.textContent);
        } catch (e) {
            devError('Bundle config parse failed', e);
            return null;
        }
    }
    static getPackConfig(container) {
        const packConfigScript = container.querySelector('[data-pack-config]');
        if (!packConfigScript) {
            devWarn('Pack config not found - single product mode');
            return null;
        }

        try {
            return JSON.parse(packConfigScript.textContent);
        } catch (e) {
            devError('Pack config parse failed', e);
            return null;
        }
    }
    static prepareInitialStatePayload(productData, formType, container) {
        const payload = {
            ...productData,
            formType,
            selectedVariantId: productData.initialSelectedVariantId,
            selectedQuantity: productData.initialSelectedQuantity,
            selectedPurchaseType: productData.initialSelectedPurchaseType
        };

        if (formType === 'multi-variant') {
            payload.quantityThresholds = ProductForm.getQuantityThresholds(container);
        }

        return payload;
    }

    hideForm() {
        devLog(`ProductForm ${this.formId}: Removing product form`);
        if (!this.container || !this.container.parentNode) {
            devWarn(`ProductForm ${this.formId}: Container already removed`);
            return;
        }

        // Clean up state to prevent memory leaks
        delete ProductFormStore.state[this.formId];
        delete ProductFormStore.listeners[this.formId];

        this.container.remove();
    }
    constructor({ container, formId }) {
        this.container = container;
        this.formId = formId;

        const formType = container.dataset.formType;

        if (!formType) {
            devError('ProductForm: data-form-type attribute is required on container');
            return;
        }

        const productData = ProductForm.getProductData(container);

        if (!productData) {
            devError('ProductForm: Product data not found');
            return;
        }

        const rechargeBundleConfig = ProductForm.getRechargeBundleConfig(container);
        if (rechargeBundleConfig) {
            productData.rechargeBundleConfig = rechargeBundleConfig;
            // devLog('rechargeBundleConfig merged into productData:', rechargeBundleConfig);
        }

        const packConfig = ProductForm.getPackConfig(container);
        if (packConfig) {
            productData.packConfig = packConfig;
            // devLog('packConfig merged into productData:', packConfig);
        }

        const initialStatePayload = ProductForm.prepareInitialStatePayload(productData, formType, this.container);
        ProductFormStore.initializeState(this.formId, initialStatePayload);

        const state = ProductFormStore.getState(this.formId);
        const isFreeProduct = state?.product?.price === 0;
        if (isFreeProduct) {
            this.hideForm();
            return;
        }

        // Initialize child components
        this.componentInstances = ComponentRegistry.initializeComponents(this.container, this.formId);

        // Initialize URL parameter watcher
        this.urlParamWatcher = new URLParamWatcher({
            formId: this.formId,
            container: this.container
        });

        this.attachEvents();
    }

    attachEvents() {

    }
}


ComponentRegistry.register('[data-product-form-component="quantity-selector-packs"]', QuantitySelectorPacks);
ComponentRegistry.register('[data-product-form-component="quantity-selector-simple"]', QuantitySelectorSimple);
ComponentRegistry.register('[data-product-form-component="quantity-selector-progress"]', QuantitySelectorProgressBar);
ComponentRegistry.register('[data-product-form-component="multi-variant-selector"]', MultiVariantSelector);
ComponentRegistry.register('[data-product-form-component="single-variant-selector"]', SingleVariantSelector);
ComponentRegistry.register('[data-product-form-component="purchase-type-selector"]', PurchaseTypeSelector);
ComponentRegistry.register('[data-product-form-component="add-to-cart-button"]', AddToCartButton);

URLParamHandlerRegistry.register('otp', ({ value, formId }) => {
    // Set purchase type to 'onetime' when ?otp=true
    if (value === 'true' || value === '1') {
        ProductFormStore.updateState(formId, {
            selections: { purchaseType: 'onetime' }
        });
        devLog(`URL param 'otp' triggered: Set purchase type to onetime`);
    }
});


document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-form]').forEach((formEl, index) => {
        new ProductForm({ container: formEl, formId: `form-${index}` });

        // Prevent the form from submitting - only attach if form wasn't hidden
        if (formEl.parentNode) {
            formEl.addEventListener('submit', (e) => {
                e.preventDefault();
            });
        }
    });
});


window.refreshProductForm = () => {
    ProductFormStore.refreshAllForms();
};